import Footer from '../components/Footer';
import Clients from '../components/landing/Clients';
import { MoreAboutUs } from '../components/landing/MoreAboutUs';
import { Opening } from '../components/landing/Opening';
import { OpeningMobile } from '../components/landing/Opening-mobile';
import { Services } from '../components/landing/Services';
import { Vmo } from '../components/landing/Vmo';

export default function Landing() {
	return (
		<div className='min-h-screen w-screen overflow-x-hidden overflow-y-scroll scroll-smooth bg-primary-800 lg:[background:radial-gradient(_89.04%_107.62%_at_87.95%_7.73%,#15513c_0%,#1c295a_28.64%,#1c295a_80%,#03081d_100%_)]'>
			<h1 className='sr-only'>Sawaed for Contracting</h1>
			<Opening />
			<OpeningMobile />
			<Clients />
			<Vmo />
			<Services />
			<MoreAboutUs />
			<Footer />
		</div>
	);
}
